import { Box, Flex, Text, VStack, Image, Button } from "@chakra-ui/react";
import { IconCheck } from "@tabler/icons-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MotionBox = motion(Box);

export const ServiceCard = ({ title, description, imageSrc, bulletPoints, reverse ,link }) => {
  return (
    <Flex
      direction={{ base: "column", md: reverse ? "row-reverse" : "row" }} // odd-even layout
      alignItems="center"
      justify="center"
      gap={10}
      my={12}
      px={4}
    >
      {/* Image Section */}
      <MotionBox
        flex="1"
        initial={{ x: reverse ? 100 : -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Image
          src={imageSrc}
          alt={title}
          w="100%"
          h="320px"
          borderRadius="lg"
          objectFit="cover"
        />
      </MotionBox>

      {/* Content Section */}
      <MotionBox
        flex="1"
        initial={{ x: reverse ? -100 : 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Text fontSize="2xl" fontWeight="bold" mb={4} color="gray.800">
          {title}
        </Text>
        <Text mb={6} color="gray.600" lineHeight="tall">
          {description}
        </Text>

        {bulletPoints && bulletPoints.length > 0 && (
          <VStack align="start" spacing={3} mb={6}>
            {bulletPoints.map((point, index) => (
              <Flex alignItems="center" key={index}>
                <IconCheck size={16} color="#B67300" style={{ marginRight: 8 }} />
                <Text color="gray.700">{point}</Text>
              </Flex>
            ))}
          </VStack>
        )}

        {/* Read More Button */}
        {link&&(
 <Button
as={Link}
to={link}

          bg="#B67300"
          color="white"
          _hover={{ bg: "#e64500" }}
          borderRadius="full"
          px={6}
        >
          Learn More
        </Button>
        )}
       
      </MotionBox>
    </Flex>
  );
};
